document.addEventListener('DOMContentLoaded', () => {
  const headerAnimation = gsap.timeline({defaults: {duration: 1, ease: "power1.in"}});

  headerAnimation
    .to(".deco-etoile", {x: "0%", y: "0%"})
    .to(".line-animation", {y: "0%", duration: 0.8}, "-=0.8")
    .to(".btn-animation", {x: "0%", duration: 1, ease: "power1.out(0.8)"}, "-=1.5")
    .to(".animation-inner .image", {opacity: 1, duration: 1.5, ease: "power1.out"}, "-=3")
    .to(".arrow-animation", {rotation: 180, duration: 3, ease: "back.out(0.8)"}, "-=3");

  gsap.to(".deco-etoile", {
    rotation: -360, duration: 4, repeat: -1, repeatDelay: 1, ease: "elastic.inOut(1, 0.5)"
  });

  ["first", "second", "third"].forEach((cls, i) => {
    gsap.to(`.animation-inner.${cls}`, {
      y: -12, repeat: -1, yoyo: true, delay: i, duration: 3, ease: "power1.inOut"
    });
  });
})
